import config from 'config';
import axios from 'helpers/axios';

const deleteApplicationRequest = (id, reason) => axios({
  method: 'delete',
  url: `${config.apiUrl}/application/${id}`,
  ...(reason ? { data: { reason } } : {}),
});

export default deleteApplicationRequest;
